import { render, staticRenderFns } from "./ProgramComposition.vue?vue&type=template&id=0ccb2dc1&scoped=true"
import script from "./ProgramComposition.vue?vue&type=script&lang=js"
export * from "./ProgramComposition.vue?vue&type=script&lang=js"
import style0 from "./ProgramComposition.vue?vue&type=style&index=0&id=0ccb2dc1&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccb2dc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ccb2dc1')) {
      api.createRecord('0ccb2dc1', component.options)
    } else {
      api.reload('0ccb2dc1', component.options)
    }
    module.hot.accept("./ProgramComposition.vue?vue&type=template&id=0ccb2dc1&scoped=true", function () {
      api.rerender('0ccb2dc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/solution/HealthcareSolutions/components/ProgramComposition.vue"
export default component.exports